/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Option1_TitleInputs */

const tr_landing_genius_option1_title = /** @type {(inputs: Landing_Genius_Option1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel AI Kredileri`)
};

const en_landing_genius_option1_title = /** @type {(inputs: Landing_Genius_Option1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel AI Credits`)
};

const de_landing_genius_option1_title = /** @type {(inputs: Landing_Genius_Option1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel AI Credits`)
};

const ru_landing_genius_option1_title = /** @type {(inputs: Landing_Genius_Option1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-кредиты ShopPanel`)
};

/**
* | output |
* | --- |
* | "ShopPanel AI Credits" |
*
* @param {Landing_Genius_Option1_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_option1_title = /** @type {((inputs?: Landing_Genius_Option1_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Option1_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_option1_title(inputs)
	if (locale === "de") return de_landing_genius_option1_title(inputs)
	if (locale === "ru") return ru_landing_genius_option1_title(inputs)
	return tr_landing_genius_option1_title(inputs)
});